'use strict';
import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

///
/// This state displays flows that the user can initiaite
///

// Register the application's routes configuration.
angular.module('flowingly.runner.exago.single').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.exagoSingle, {
    url: 'processdashboard',
    params: { title: 'Flow Dashboard' },
    controller: 'runnerExagoControllerSingle',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.exago.single/runner.exago.single.tmpl.html'
  });
}
